import React from "react";
import styles from "./styles/stem-splitter-categories-bar.module.scss";
import StemSplitterCategoryItem from "@/components/pages/stem-splitter/components/stem-splitter-category-item";
import { categories } from "@/data/stem-splitter-categories.constants";

const StemSplitterCategoriesBar = () => {
  return (
    <div className={styles.wrapper}>
      {categories.map((category) => (
        <StemSplitterCategoryItem key={category} title={category} />
      ))}
    </div>
  );
};

export default StemSplitterCategoriesBar;
